import React from 'react';
import { BannerItem } from '@nxsys/types/models/banner';
import {
  StyledBannerCard,
  StyledBannerContent,
  StyledNewUpdateBadge,
  StyledCheckNowButton,
} from './index.styled';
import DecorativeBannerBackground from './DecorativeBannerBackground';
import { Icons } from '@nxsys/types/icons';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

type AppBannerCardProps = {
  banner: BannerItem;
  onClick?: () => void;
};

const AppBannerCard: React.FC<AppBannerCardProps> = ({ banner, onClick }) => {
  const hasCustomBackground = !!banner.portalBackgroundImageUrl;

  return (
    <StyledBannerCard
      onClick={onClick}
      backgroundImage={banner.portalBackgroundImageUrl || null}
      hasCustomBackground={hasCustomBackground}
    >
      {!hasCustomBackground && <DecorativeBannerBackground />}
      <StyledBannerContent>
        <StyledNewUpdateBadge>
          <Icons.IconRocket
            width={12}
            height={12}
            color={defaultTheme.theme.palette.warning[300]}
          />
          <span>New Update</span>
        </StyledNewUpdateBadge>
        <div className="banner-summary">{banner.summary}</div>
        <StyledCheckNowButton onClick={onClick}>
          Check Now
          <Icons.IconArrowUpRight
            width={16}
            height={16}
            color={defaultTheme.theme.palette.primary[600]}
          />
        </StyledCheckNowButton>
      </StyledBannerContent>
    </StyledBannerCard>
  );
};

export default AppBannerCard;
